import { getLocalTimeZone, today } from '@internationalized/date';
import { Trans, useLingui } from '@lingui/react/macro';
import { parseISO } from 'date-fns/parseISO';

import InputDate from '@/design_system/InputDate';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const PurchaseDate = () => {
  const { t } = useLingui();
  const { request, article, view, errors } = useArticleContext();

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  const isDisabled = !!article.dataFromPurchaseHistory?.purchaseDate;

  return (
    <InputDate
      label={
        <>
          <Trans id="article.form.purchase-date.label">Purchase date</Trans>
          {!view.warranty.fields.purchaseDate.required && !isDisabled && <OptionalLabel />}
        </>
      }
      value={article.purchaseDate}
      onChange={(date) => {
        if (date && parseISO(date) <= new Date()) {
          if (date !== article.purchaseDate) {
            updateArticle({
              data: {
                purchaseDate: date,
              },
            });
          }
        } else {
          updateArticle({
            data: {
              purchaseDate: null,
            },
          });
        }
      }}
      maxValue={today(getLocalTimeZone())}
      isDisabled={isDisabled}
      style={{ flex: 1 }}
      error={
        errors.warranty?.missingPurchaseDate
          ? t({
              id: 'article.form.purchase-date.error.missing',
              message: 'A purchase date is required',
            })
          : errors.warranty?.invalidPurchaseDate
            ? t({
                id: 'article.form.purchase-date.error.invalid',
                message: 'The purchase date must be in the past',
              })
            : undefined
      }
    />
  );
};
